export default "# Bladeburners\n\nPLACEHOLDER\n";